<template>
<div class="agenda__item-speaker-item">
  <div class='agenda__item-speaker-item-circle detail-page-speaker-circle rounded-circle' v-bind:style="avatarStyle">
    <span v-if="!this.userAvatarUrl">
      {{ `${firstInitial}${lastInitial}` }}
    </span>
  </div>
  <div class="agenda__item-speaker-item-details flex-fill">
    <a class="speaker-details-link" :href="directoryPath">
      <div class="agenda__item-speaker-name">
        <span class="agenda__item-speaker-item-details-first">
          {{ firstName }}
        </span>
        <span class="agenda__item-speaker-item-details-last">
          {{ lastName }}
        </span>
        <span class="agenda__item-speaker-item-detailsspeaker-title dash" v-if="hasSpeakerDescription">  -  </span> 
      </div>
      <div class="agenda__item-speaker-item-desc" v-if="speaker.speaker_description">
        <p class="agenda__item-speaker-subtitles"  v-html="speaker.speaker_description"></p>
      </div>
      <div class="agenda__item-speaker-item-desc" v-else-if="speaker._directory_subheader1 || speaker._directory_subheader2">
        <p class="agenda__item-speaker-subtitles" v-html="speaker._directory_subheader1"></p>
        <p class="agenda__item-speaker-subtitles" v-show="speaker._directory_subheader1 && speaker._directory_subheader2" >{{', '}}</p>
        <p class="agenda__item-speaker-subtitles" v-html="speaker._directory_subheader2"></p>
      </div>
    </a>
  </div>
</div>
</template>

<script>

export default {
  
  props: {
    speaker: Object
  },

  computed: {

    avatarStyle: function () {
      return this.userAvatarUrl 
        ? {'background-image': 'url("' + this.userAvatarUrl + '")'} 
        : {}
    },

    hasSpeakerDescription: function () {
      return (this.speaker.speaker_description || (this.speaker._directory_subheader1 || this.speaker._directory_subheader2))
    },

    directoryPath: function() {
      var directoryId = (this.speaker.directory_id) ? this.speaker.directory_id : this.speaker.directory.id
      var eaId = (this.speaker.event_attendee_id) ? this.speaker.event_attendee_id : this.speaker.event_attendee.id

      return `/directories/${directoryId}/attendee/${eaId}` 
    },

    userAvatarUrl: function() {
      return (this.speaker.user_avatar_url) ? this.speaker.user_avatar_url : this.speaker?.event_attendee?.attendee_fields?.user_avatar_url;
    },

    firstInitial: function () {
      return (this.firstName && this.firstName.charAt(0)) || '';
    },

    lastInitial: function () {
      return (this.lastName && this.lastName.charAt(0)) || '';
    },
    
    firstName: function () {
      return (this.speaker.first_name) ? this.speaker.first_name : this.speaker?.event_attendee?.attendee_fields?.first_name
    },

    lastName: function () {
      return (this.speaker.last_name) ? this.speaker.last_name : this.speaker?.event_attendee?.attendee_fields?.last_name
    },

  }
  
}


</script>

